module.exports = __webpack_public_path__ + "resources/img/img_mazebolt2_m.f1a319f49592c5178887a07c0d0bb423.png";